import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Goal.css";
import Images from "../../Assets/Images/Index";
import { ArrowRight } from "lucide-react";
import axios from "axios"
function Goal() {
  const navigate = useNavigate();
  const [goals, setGoals] = useState([]);

  const fetchGoals = async () => {
    try {
      const response = await axios.get(
        "https://qflyers.minipossystem.com/api/v1/register-data"
      );
      console.log({ goals: response.data.goals });
      setGoals(response.data.goals);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchGoals();
  }, []);

  // const cardsData = [
  //   {
  //     id: 1,
  //     title: "Cafe",
  //     text: `A coffee shop named "Goal Coffee" could have a really inspiring and cozy vibe! 
  //     Imagine it being a place where people go to fuel their ambitions—whether they’re working on their dreams, studying, or taking a much-needed break.  
  //     It could offer signature drinks named after different goals, like "Startup Espresso" or "Dreamer’s Latte," making every cup an inspiration.`,
  //     image: Images.card1,
  //   },
  //   {
  //     id: 2,
  //     title: "Street Food",
  //     text: `Street food culture is all about energy, variety, and affordability.  
  //     Picture vibrant food trucks serving gourmet burgers, spicy tacos, or sizzling kebabs, each offering a unique culinary adventure.  
  //     With live cooking stations and engaging customer interactions, it's a foodie’s paradise that brings communities together.`,
  //     image: Images.card2,
  //   },
  //   {
  //     id: 3,
  //     title: "Restaurant",
  //     text: `A restaurant named "Goal Restaurant" could be a unique concept that blends great food with personal achievement.  
  //     The ambiance would be warm and welcoming, with motivational decor that celebrates milestones.  
  //     Guests could enjoy a specially crafted "Success Menu," featuring dishes inspired by famous entrepreneurs and innovators.`,
  //     image: Images.card3,
  //   },
  //   {
  //     id: 4,
  //     title: "Medical Store",
  //     text: `A medical store isn’t just a place to buy equipment—it’s a hub of wellness and care.  
  //     It offers a comprehensive range of medical tools, from basic first-aid kits to advanced diagnostic equipment, catering to healthcare professionals and home caregivers.  
  //     With a focus on quality and accessibility, it ensures that medical essentials are available when they’re needed the most.`,
  //     image: Images.card4,
  //   },
  //   {
  //     id: 5,
  //     title: "Tool Shop",
  //     text: `A tool shop serves as a one-stop destination for handymen, builders, and DIY enthusiasts.  
  //     Whether it's power drills, wrenches, or precision tools, this store provides high-quality equipment for all types of projects.  
  //     With expert guidance available, customers can make informed choices and complete their work with efficiency and confidence.`,
  //     image: Images.card5,
  //   },

  //   {
  //     id: 6,
  //     title: "Construction Shop",
  //     text: `A construction shop is a hub for professionals and DIY builders, offering a wide range of materials, tools, and safety gear.  
  //       From cement, bricks, and steel to power tools and heavy machinery, it supplies everything needed for small projects and large-scale constructions.  
  //       With expert advice and quality products, it ensures durability, efficiency, and safety for every building endeavor.`,
  //     image: Images.card6,
  //   },
  // ];
  const handleLearnMore = (card) => {
    navigate("/LearnMore", { state: { card } });
  };
  return (
    <div>
      <Header />
      <div className="goal-cont">
        <div className="goal-main-cont container">
          <h1>
            Describe Your Goal for using
            <span className="highlight"> QFLyers</span>
          </h1>
          <p>
            My goal for using QFlyer is to efficiently create and manage
            professional flyers for promoting services, events, or products. By
            utilizing QFlyer’s tools, I aim to design visually appealing,
            informative, and easily shareable flyers to reach a wider audience,
            increase engagement, and drive action for the intended purpose.
          </p>
          <div className="goalcard-container mt-5">
            {goals.map((card) => (
              <div
                className="goalcard"
                style={{ width: "18rem" }}
                key={card.id}
                data-aos="zoom-in"
              >
                <img
                  className="goalcard-img-top"
                  src={card.image}
                  alt="Card image cap"
                />
                <div className="goalcard-body">
                  <h5 className="goalcard-title">{card.name}</h5>
                  <p className="goalcard-text">
                    {card.description.length > 100
                      ? card.description.substring(0, 100) + "..."
                      : card.description}
                  </p>
                </div>
                <div className="arrow-container">
                  <ArrowRight onClick={() => handleLearnMore(card)} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Goal;
